export const odluka_potpora_za_novorodeno_dijete = {
    templateId: 39,
    category: 4,
    templateTitle: "Odluka - potpora za novorođeno dijete",
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku potporu za novorođeno dijete, pri čemu je navedena isplata neoporeziva do 10.000,00 kn.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubraja se i potpora za novorođeno dijete.</p>
    <p>Poslodavci mogu radnicima neoporezivo isplatiti potporu za novorođeno dijete do 10.000,00 kn.</p>
    <p>Potpora za novorođeno dijete smatra se materijalnim pravom radnika, a koje nije izravno propisano Zakonom o radu, nego se po potrebi uređuje kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnim ugovorom odnosno ako nije određeno ugovorom o radu, onda poslodavac samostalno odlučuje hoće li to pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Također, potpora za novorođeno dijete je za poslodavca porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no samo do 10.000,00 kn.</p>
    <p>Osim toga, prema odredbama Ovršnog zakona, potpora za novorođeno dijete do propisanog neoporezivog iznosa primitka po osnovi nesamostalnog rada izuzeta je od ovrhe te se u slučaju blokade računa radnika uplaćuje na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).</p>
    <p>Međutim, ovaj primitak je izuzet od ovrhe samo do propisanih iznosa do kojih se smatraju neoporezivim primicima po osnovi od nesamostalnog rada, što znači da se u dijelu u kojem se smatraju oporezivim primicima po osnovi od nesamostalnog rada ne mogu isplatiti na zaštićeni, već na redovni račun.</p>
    <p>Poslodavac može potporu za novorođeno dijete isplatiti radniku u gotovini iz blagajne ili na tekući račun, a isplata može biti obavljena uz isplatu redovne plaće ili posebno.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: ' ODLUKU O ISPLATI NOVČANE POTPORE ZA NOVOROĐENO DIJETE ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Dana'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine,'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz',},
                        { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'OIB:' },
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: '(u daljnjem tekstu: Radnik), postao je roditelj.'},
                    ],
                },
              ],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Imenovani Radnik je roditeljstvo iz ove Odluke potvrdio dostavljanjem preslike Izvatka iz matice rođenih. ',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'S obzirom na gore navedeno, Poslodavac je odlučio isplatiti Radniku potporu za rođenje djeteta u iznosu od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'kn.'}],
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Potpora se isplaćuje u roku od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana od dana donošenja ove Odluke.'}],
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Potpora iz ove Odluke isplaćuje se na redovan račun Radnika, no u slučaju da Radnik ima otvoren zaštićeni račun, sredstva se doznačuju na zaštićeni račun.',
                        'Poslodavac će potporu iz ove Odluke isplatiti Radniku u gotovini.'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Ukoliko postoji zakonska mogućnost korištenja neoporezive isplate, pri isplati novčane potpore za rođenje djeteta iskoristiti će se ta porezna mogućnost. ',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};
        


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/39_odluka_potpora_za_novorodeno_dijete.ts